import { useMemo } from 'react'
import { useParams } from 'wouter'
import { skipToken, useSuspenseQuery } from '@apollo/client'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'
import { dateTime } from '@guestgoodie/helpers'
import { useLingui } from '@lingui/react/macro'

import { Suspense } from '@/components/ui/Suspense'
import { EventParticipants } from '@/features/order'
import { DialogHeader } from '@/layouts/Dialog'

function EditEventOccurence({ token }: { token: string }) {
  const { t } = useLingui()

  const { data } = useSuspenseQuery(AdminAPI.eventOccurence.GET_BY_TOKEN, {
    variables: { token },
    fetchPolicy: 'cache-and-network'
  })

  const eventOccurence = useMemo(
    () =>
      getFragment(
        SharedAPI.eventOccurence.EVENT_OCCURENCE_FRAGMENT,
        data.getEventOccurenceByToken
      ),
    [data]
  )

  const { data: goodieData } = useSuspenseQuery(
    AdminAPI.goodie.GET,
    eventOccurence
      ? {
          variables: { id: eventOccurence.goodieId }
        }
      : skipToken
  )

  const goodie = useMemo(() => {
    return getFragment(SharedAPI.goodie.GOODIE_FRAGMENT, goodieData?.getGoodie)
  }, [goodieData])

  const goodieTitle = goodie?.title

  const eventStart = dateTime.fullFormatter.format(
    new Date(eventOccurence.startAt)
  )

  return (
    <div className="flex flex-col gap-2 p-5">
      <DialogHeader
        title={t`Edit "${goodieTitle}"`}
        description={t`Edit, Accept or Reject of event Members of the event "${goodieTitle}", ${eventStart}`}
      />
      <EventParticipants id={eventOccurence.id} />
    </div>
  )
}

export default function EditEventOccurenceSuspense() {
  const params = useParams() as { token: string }

  if (!params) return null

  return (
    <Suspense isDialog>
      <EditEventOccurence token={params.token} />
    </Suspense>
  )
}
